import { styled } from "styled-components";
import useMeasure from "react-use-measure";
import { ActionToastRegion } from "@fidelix/fx-miranda";
import { HistoryReplayPlayButton } from "./history-replay-play-button";
import { HistoryReplayPlaybackSpeedButton } from "./history-replay-playback-speed-button";
import { minReplayContainerHeight } from "../graphics-view";
import { HistoryReplayDatePicker } from "./history-replay-date-picker";
import { HistoryAddPreviewPointsButton } from "./history-add-preview-points-button";
import { HistoryReplayZoom } from "./history-replay-zoom";
import { HistoryTimelineContainer } from "./history-timeline-container";
import { historyToasts } from "./history-resolution-toast";

type Props = { height: number; isResizing: boolean };

export function HistoryReplayContainer({ height, isResizing }: Props) {
  const [innerRef, { width }] = useMeasure();

  const zoomTimeLineContainerWidth = width - 145;

  return (
    <Container style={{ minHeight: minReplayContainerHeight, height: height }}>
      <ActionToastRegion
        bottomPx={window.innerHeight - 200}
        queue={historyToasts.queue}
      />
      <HistoryReplayPlayButton />
      <InnerContainer ref={innerRef}>
        <UpperContainer>
          <HistoryTimelineContainer width={zoomTimeLineContainerWidth} />
          <HistoryReplayPlaybackSpeedButton />
          <HistoryReplayDatePicker />
        </UpperContainer>
        <LowerContainer style={{ height: height - 50 }}>
          <HistoryReplayZoom
            isResizing={isResizing}
            width={zoomTimeLineContainerWidth}
          />
          <HistoryAddPreviewPointsButton />
        </LowerContainer>
      </InnerContainer>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  border-top: 1px solid ${(p) => p.theme.colors.darkNeutral};
  background: ${(p) => p.theme.colors.mutedNeutralBackground};
  box-shadow: 0px -4px 4px ${(p) => p.theme.colors.black}26;
  gap: ${(p) => p.theme.space("xxsmall")};
  align-items: start;
  justify-content: start;
`;

const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(100% - 50px);
`;
const UpperContainer = styled.div`
  margin-top: ${(p) => p.theme.space("xxsmall")};
  padding-right: ${(p) => p.theme.space("xxsmall")};
  height: ${(p) => 50 - p.theme.spaceNumber("xxsmall")}px;
  display: grid;
  grid-template-columns: auto 65px 65px;
  gap: ${(p) => p.theme.space("small")};
`;

const LowerContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: auto 130px;
  gap: ${(p) => p.theme.space("small")};
`;
